import { createContext } from 'react';

export interface ResourceContextValue {
  resource: string | null;
}

export const ResourceContext = createContext<ResourceContextValue>({ resource: null });
